import api from "utils/axios";

function formatNumber(num) {
  if (num === undefined || num === null) return "0";
  const rounded = Math.round(num);
  return rounded.toLocaleString();
}

function getDeltaColor(delta) {
  if (delta > 0) return "success";
  if (delta < 0) return "error";
  return "text";
}

function processMetric(data) {
  if (!data) return { total: 0, delta: 0, label: "", color: "text" };

  const delta = data.delta || 0;
  return {
    total: formatNumber(data.total),
    delta,
    label: data.label || "",
    color: getDeltaColor(delta),
  };
}

function processRevenue(revenue) {
  return {
    total: {
      total: formatNumber(revenue?.total?.total),
      delta: revenue?.total?.delta || 0,
      label: revenue?.total?.label || "",
      color: getDeltaColor(revenue?.total?.delta),
    },
    today: {
      total: formatNumber(revenue?.today?.total),
      delta: revenue?.today?.delta || 0,
      label: revenue?.today?.label || "",
      color: getDeltaColor(revenue?.today?.delta),
    },
  };
}

export async function getDashboardCounts() {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/dashboard/dashboard-counts`);
    const raw = data.data || {};

    return {
      users: processMetric(raw.users),
      recruiters: processMetric(raw.recruiters),
      candidates: processMetric(raw.candidates),
      todaysUsers: processMetric(raw.todaysUsers),
      jobs: {
        total: formatNumber(raw.jobs?.total),
        delta: raw.jobs?.delta || 0,
        label: raw.jobs?.label || "",
        color: getDeltaColor(raw.jobs?.delta),
        pending: formatNumber(raw.jobs?.pending),
        active: formatNumber(raw.jobs?.active),
      },
      applications: processMetric(raw.applications),
      revenue: processRevenue(raw.revenue),
    };
  } catch (error) {
    console.error(error);
    return {};
  }
}

export async function getChartData() {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/dashboard/get-chart-data`);
    return data.data;
  } catch (error) {
    console.error("Error fetching chart data:", error);
    return {};
  }
}
